import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import LogoPolderzicht from '../assets/logo_polderzicht_kantoorlaag.png';
import '../css/Beoordeling.css';

const API_BASE = process.env.REACT_APP_API_URL || '';

const fileIdFromUrl = (url) => {
  if (!url) return null;
  const m = String(url).match(/\/d\/([a-zA-Z0-9_-]+)/);
  return m ? m[1] : null;
};
const photoSrc = (f) => {
  const id = f.driveFileId || fileIdFromUrl(f.driveUrl);
  return id ? `${API_BASE}/api/inspections/photo/${id}` : f.driveUrl;
};

const Beoordeling = () => {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorState, setErrorState] = useState(null);
  const [sterren, setSterren] = useState(0);
  const [hover, setHover] = useState(0);
  const [toelichting, setToelichting] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [klaar, setKlaar] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/api/schilderwerk/beoordeling/${token}`);
      if (res.status === 404) { setErrorState('notfound'); return; }
      if (res.status === 410) { setErrorState('expired'); return; }
      if (!res.ok) { setErrorState('generic'); return; }
      const json = await res.json();
      setData(json);
      if (json.alBeoordeeld) setKlaar(true);
    } catch {
      setErrorState('generic');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const verstuur = async () => {
    if (!(sterren >= 1)) return;
    setSubmitting(true);
    try {
      const res = await fetch(`${API_BASE}/api/schilderwerk/beoordeling/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sterren, toelichting })
      });
      if (!res.ok) throw new Error();
      setKlaar(true);
    } catch {
      setErrorState('generic');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div className="bo-page"><div className="bo-card"><p>Laden…</p></div></div>;

  if (errorState) {
    const msg = {
      notfound: 'Deze link bestaat niet (meer).',
      expired: 'Deze link is verlopen.',
      generic: 'Er ging iets mis. Probeer het later opnieuw.'
    }[errorState];
    return (
      <div className="bo-page"><div className="bo-card">
        <img src={LogoPolderzicht} alt="VVE Polderzicht" className="bo-logo" />
        <p className="bo-error">{msg}</p>
      </div></div>
    );
  }

  return (
    <div className="bo-page">
      <div className="bo-card">
        <img src={LogoPolderzicht} alt="VVE Polderzicht" className="bo-logo" />
        <h1>Schilderwerk balkon {data.huisnummer}</h1>

        {klaar ? (
          <div className="bo-thanks">
            <p>Bedankt voor uw beoordeling! 🎉</p>
          </div>
        ) : (
          <>
            <p>Het schilderwerk aan uw balkon is afgerond. Hoe tevreden bent u?</p>
            <div className="bo-stars">
              {[1, 2, 3, 4, 5].map(n => (
                <span
                  key={n}
                  className={`bo-star ${(hover || sterren) >= n ? 'on' : ''}`}
                  onMouseEnter={() => setHover(n)}
                  onMouseLeave={() => setHover(0)}
                  onClick={() => setSterren(n)}
                  role="button"
                  aria-label={`${n} sterren`}
                >★</span>
              ))}
            </div>
            <textarea
              className="bo-toelichting"
              rows={3}
              placeholder="Toelichting (optioneel)"
              value={toelichting}
              onChange={e => setToelichting(e.target.value)}
            />
            <button className="bo-btn" disabled={!sterren || submitting} onClick={verstuur}>
              {submitting ? 'Versturen…' : 'Beoordeling versturen'}
            </button>
          </>
        )}

        {((data.fotosVoor && data.fotosVoor.length) || (data.fotosNa && data.fotosNa.length)) > 0 && (
          <div className="bo-fotos">
            {data.fotosVoor && data.fotosVoor.length > 0 && (
              <div><h3>Vooraf</h3><div className="bo-fotorij">{data.fotosVoor.map((f, i) => <img key={i} src={photoSrc(f)} alt="voor" loading="lazy" />)}</div></div>
            )}
            {data.fotosNa && data.fotosNa.length > 0 && (
              <div><h3>Na afloop</h3><div className="bo-fotorij">{data.fotosNa.map((f, i) => <img key={i} src={photoSrc(f)} alt="na" loading="lazy" />)}</div></div>
            )}
          </div>
        )}

        <div className="bo-footer">
          <p>Vragen? Mail <a href="mailto:bestuurpolderzicht@gmail.com">bestuurpolderzicht@gmail.com</a></p>
        </div>
      </div>
    </div>
  );
};

export default Beoordeling;
